import React, { useEffect, PropsWithChildren } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';
import { WebshopNavigation } from '@gjensidige/se-webshop-navigation';

import { useAppDispatch } from '../hooks/appHooks';
import APP_CONSTANTS from '../lib/constants/appConstants';
import { HEADER_CONSTANTS } from '../lib/constants/appConstants';
import { setProductName } from '../store/slices/offerSlice';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { TextHelper } from '../utils/TextHelper';
import InsuranceStep from './Steps/InsuranceStep/InsuranceStep';
import PriceCalculationStep from './Steps/PriceCalculationStep/PriceCalculationStep';
import { TrackingHelper } from '../utils/TrackingHelper';
import tracker from '../tracking.js';

const PurchaseFlow: React.FC = () => {
  const dispatch = useAppDispatch();
  const { product, page } = useParams();
  useEffect(() => {
    if (product && APP_CONSTANTS.productList.includes(product)) {
      dispatch(setProductName(product));
    }
  }, []);
  const GjensidigeImgUrl =
    fetchGenericIllustrations('Gjensidige', IllustrationType.DETAILED, [
      {
        name: 'Gjensidige',
        filename: 'Gjensidige',
        fileType: 'svg'
      }
    ]) || '';
  const channel = InsuranceHelper.getChannelInfo();
  
  const getTracker = () => {
    // @ts-expect-error
    tracker.options.scenario_step = TrackingHelper.getScenarioStepFromPage(page);
    // @ts-expect-error
    tracker.options.scenario_name = TrackingHelper.getScenarioNameFromProduct(product);
    return tracker;
  }
  return (
  
      page === "calculation" 
      ? 
        <PriceCalculationStep productName={product || ""}/>
      :
      <>
        <WebshopNavigation
            customerCareNumber={TextHelper.getCustomerCareNumber(
              channel.toLowerCase()
            )}
            openHours={HEADER_CONSTANTS.OPEN_HOURS}
            imageAlt={HEADER_CONSTANTS.IMAGE_ALT}
            imageSrc={GjensidigeImgUrl}
            trackingObject={getTracker()}
        />
        <InsuranceStep product={product || ""} page={page || ""}></InsuranceStep>
      </>
  );
};

export default PurchaseFlow;
